import { z } from 'zod';
import { AddressSchema as CoreAddressSchema } from '@triedge/domain-core/value-objects';

const { street, city, state, zipCode } = CoreAddressSchema.shape;

export const AddressSchema = z.object({
  street: street.optional().nullable(),
  city: city.optional().nullable(),
  state: state.optional().nullable(),
  zipCode: zipCode.optional().nullable(),
});

export type Address = z.infer<typeof AddressSchema>;
